import React from "react";
import PropTypes from "prop-types";
import ToggleSwitch from "../../../components/common/Toggle/ToggleSwitch";

const NotificationsCard = ({ image, title, content, checked, onChange }) => {
  return (
    <div className="flex flex-row justify-between items-start px-[30px] py-3">
      <img
        src={image}
        alt={title || "Notification icon"}
        className="w-6 h-6 object-cover"
      />
      <div className="flex-1 mx-4">
        <h3 className="font-primary font-medium text-[18px] xs:text-[1.25rem] leading-[28px] tracking-normal">
          {title}
        </h3>
        <span className="font-primary font-medium text-[14px] xs:text-base leading-[24px] tracking-normal text-[#A0A0A0]">
          {content}
        </span>
      </div>
      <ToggleSwitch checked={checked} onChange={onChange} />
    </div>
  );
};

NotificationsCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default NotificationsCard;
